<template>
    <div>
        <h1>
            <div class="left">{{name}}</div>
        </h1>
    </div>
</template>

<script>
export default {
    data() {
        return {
            name
        }
    },
    props: [
        'routerName'
    ],
    mounted() {
        this.name = this.routerName;
    },
    methods: {

    }
}
</script>

<style lang='scss' scoped>
h1 {
    padding: 20px 50px;
    border-bottom: 1px solid #dbdbdb;
    background: #F3F3F3;
    user-select: none;
    .left {
        border-left: 3px solid coral;
        padding-left: 10px;
        color: #666;
    }
}
</style>